import localStorage from "shared/helpers/localStorage";
import es6Promise from "es6-promise";
import { UPDATE_PAGE_CONTENT } from "shared/constants/appConstants";

es6Promise.polyfill();
// es lint:
/* global Promise */

export class LocalTableResource {
  constructor(dispatch, tableName) {
    this.dispatch = dispatch;
    this.tableName = tableName;
  }

  put = (key, value) => {
    return new Promise(resolve => {
      const data = JSON.parse(localStorage.get(this.tableName)) || {};

      if (value !== "_destroy") {
        data[key] = value;
      } else {
        delete data[key];
      }

      localStorage.set(this.tableName, JSON.stringify(data));

      this.dispatch({
        type: UPDATE_PAGE_CONTENT,
        payload: { [this.tableName]: data }
      });

      resolve({ status: 200 }); // fakes a successful apiRequest response
    });
  };

  get = () => {
    return new Promise(resolve => {
      const data = JSON.parse(localStorage.get(this.tableName)) || {};

      this.dispatch({
        type: UPDATE_PAGE_CONTENT,
        payload: { [this.tableName]: data }
      });

      resolve({ status: 200 }); // fakes a successful apiRequest response
    });
  };
}

export class SectionCompletedResource extends LocalTableResource {
  constructor(dispatch) {
    super(dispatch, "sectionCompleted");
  }
}
